module.exports = __webpack_public_path__ + "img/20210906-1630911194868529.8bfe6acf.jpg";